var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1.1
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 16,
    cy: 7,
    r: 7,
    fill: "#8E0000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#C3EEFD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/1.1.5bec3bfd659ffdf6e6cfe4251bd56587.svg";
export { ForwardRef as ReactComponent };